export { FeatureGridDS, default } from './feature-grid-ds'
export type { FeatureGridDSProps } from './feature-grid-ds.types'
